import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'spinner-component',
  template: require('./spinner.component.html'),
  styles: [require('./spinner.component.css')]
})
export class SpinnerComponent implements OnInit {
  @Input() showDisplay: boolean = false;

  constructor(){}

  ngOnInit() {}

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/components/spinner/spinner.component.ts
 **/